// extracted by mini-css-extract-plugin
export default {"root":"Internal__root--fygB17","header":"Internal__header--k04CfY"};